import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { getErrorMessage } from '../lib/error-handling';
import { VriAPIResponse, VriAPIResult } from '../types';

export interface MuteOptions {
    roomname: string;
}

export interface MuteResponse extends VriAPIResponse {
    data: null;
}

export interface MuteResult extends VriAPIResult {
    data?: {
        message: string;
    };
}

export async function muteVoiceConference(options: MuteOptions): Promise<MuteResult> {
    const result: MuteResult = {};

    try {
        const { data: responseData } = await axios.post<MuteResponse>(
            END_POINT.MUTE_USER_VOICE_CONFERENCE,
            options,
        );
        if (responseData) {
            result.data = { message: responseData.message };
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }

    return result;
}

export interface UnmuteOptions {
    roomname: string;
}

export interface UnmuteResponse extends VriAPIResponse {
    data: null;
}

export interface UnmuteResult extends VriAPIResult {
    data?: {
        message: string;
    };
}

export async function unmuteVoiceConference(options: UnmuteOptions): Promise<UnmuteResult> {
    const result: UnmuteResult = {};

    try {
        const { data: responseData } = await axios.post<UnmuteResponse>(
            END_POINT.UNMUTE_USER_VOICE_CONFERENCE,
            options,
        );
        if (responseData) {
            result.data = { message: responseData.message };
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }

    return result;
}
